export default __webpack_public_path__ + "80825f79c5eced3cefa99ee4356dc421.png";